import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const ofertasmodule = {
	state: {
		ofertas : [],
		ofertasDestacadas : null,
		npages : '',
		nOfertas : 0
	},
	getters: {
		getOfertas : state => state.ofertas,
		getOfertasDestacadas : state => state.ofertasDestacadas,
		getNpages : state => state.npages,
		getNofertas : state => state.nOfertas,
		getubicaciones : state => {
			let ubicaciones = new Array();
			if(!!state.ofertas){
				state.ofertas.forEach(o => {
					if(!ubicaciones.some(u => u == o.provincia)){
						ubicaciones.push(o.provincia);
					}
				});
			}

			ubicaciones = ubicaciones.sort(function (p1, p2) {
				return (p1 < p2) ? -1 : 1;
			})

			return ubicaciones;
		},
		hasExperiencias : state => {
			let experiencias = new Array();
			if(!!state.ofertas){
				state.ofertas.forEach(o => {
					if(!experiencias.some(u => u == o.experiencia)){
						experiencias.push(o.experiencia);
					}
				});
				return experiencias.some(e => !!e);
			}else{
				return false;
			}

		}
	},
	actions: {
        requestOferta({commit},slug){
            return new Promise((resolve, reject) => {
				axios.post('/ws/getOferta',{"slug":slug}).then( result => {
                    if(result.data.status == 0){
						resolve(result.data);
					}else{
						commit('setError',result.data.status);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		inscripcionOferta({commit},slug){
            return new Promise((resolve, reject) => {
				axios.post('/ws/inscripcion',{"slug":slug}).then( result => {
					if(result.data.status == 0){
						resolve(true);
					}else{
						commit('setError',result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		requestFirstsOfertas({dispatch,commit}){
			return new Promise((resolve, reject) => {
				axios.post('/ws/getOfertas',1).then( result => {
					if(result.data.status == 0){
						resolve(result.data.ofertas.slice(0,2));
						commit('setNPages',result.data.numTotal);
						dispatch('requestAllOfertas',1);
					}else{
						commit('setError',result.data.status);
						dispatch('sendInfoAboutError',result.data);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		requestAllOfertas({dispatch,getters},page){
			return new Promise((resolve, reject) => {
					dispatch('getOfertaPage',page).then(r=>{
						if(r){
							page++;
							if(page <= getters.getNpages){
								dispatch('requestAllOfertas',page);
							}
						}
					})		
			});	
		},
		requestOfertasDestacadas({commit}){
			return new Promise((resolve, reject) => {
				axios.post('/ws/getOfertasDestacadas').then( result => {
					if(result.data.status == 0){
						commit('setOfertasDestacadas', result.data.ofertas);
						resolve(result.data.ofertas);
					}else{
						commit('setError',result.data.status);
						dispatch('sendInfoAboutError',result.data);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		getOfertaPage({commit},page){
			return new Promise((resolve, reject) => {
				axios.post('/ws/getOfertas',page).then( result => {
					if(result.data.status == 0){
						commit('addOFertas',result.data.ofertas);
						resolve(true);
					}else{
						commit('setError',result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  
			});
		},
		requestDesincripcion({commit},url){
			return new Promise((resolve, reject) => {
				axios.get(`/ws/desinscripcion?url=${url}`).then( result => {
					if(result.data.status == 0){
						resolve(true);
					}else{
						commit('setError',result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});  
			});
		},
	},
	mutations: {
		addOFertas(state, ofertas){
			state.ofertas = state.ofertas.concat(ofertas);
		},
		setOfertasDestacadas(state, ofertas){
			state.ofertasDestacadas  = ofertas;
		},
		setNPages(state, total){
			const perpage = 20;
			let peticiones = Math.ceil(total / perpage);
			state.npages = peticiones;
			state.nOfertas = total;
		}
	}
}

export default ofertasmodule;


// WEBPACK FOOTER //
// ./src/store/ofertasmodule.js